// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const baseUrl: string = 'https://localhost:4200';

export const environment = {
  version: '1.0.0',
  title: 'Web-QUL DEV',
  titleRoute: 'Web-QUL DEV | ',
  production: false,
  uat: false,
  apiUrl: 'https://api-qul.bybrickelevate.xyz/api',
  contractTypesWithDeviantAppearingTime: [4, 5, 15, 16],
  
  proQulLink: 'https://google.se',
  cardTeamId: 489,
  resetMFA: 'https://identity.bybrickelevate.xyz/Identity/Account/Manage/TwoFactorAuthentication',
  changePassword: 'https://identity.bybrickelevate.xyz/Identity/Account/Manage/ChangePassword',

  // statuses
  statusOpen: 28,
  statusOnGoing: 29,
  statusRevisit: 31,
  statusDone: 30,
  statusAssigned: 570,
  statusInvoicedQUL: 27,
  statusInvoicedAgresso: 25,
  statusAttest: 26,
  statusRH: 783,

  // so class
  soClassErrorAssignment: 725,
  soClassOrderAssignment: 726,
  soClassOtherAssignment: 727,
  soClassCardOrderAssignment: 1164,
  soClassTechnicianContactAssignment: 1165,

  // so Issued
  soIssuedCustomer: 1,
  soIssuedTechnician: 2,
  soIssuedSalesPerson: 3,
  soIssuedOther: 4,

  // team types
  teamTypeCostCenter: 1,
  teamTypeFollowUp: 2,
  teamTypeOnCall: 3,
  teamTypeCallList: 4,
  teamTypeRemote: 5,
  teamTypeFirstLineSupport: 6,
  teamTypeAuth: 7,

  // site kinds
  internalSite: 322,
  materialSite: 323,

  // role Id's
  sysAdminRole: 151,
  businessSupportRole: 142,
  prodManagerRole: 145,
  departmentResponsibleRole: 149,

  //securitas technology tech
  secTecId: 1700,

  // invociePage UnselectedCostCenters
  unselectedCostCenters: [644],

  webTimeReportLink: 'http://10.130.19.20:6744/login/',

  priorityFiveId: 21,
  prioSoPollInterval: 60000, // 1 minutes in milliseconds

  rsIdProtocol: 2018,
  rsIdInternProtocol: 2019,

  leasingSotId: 253,
  rsLeasingAgreementId: 2021,
  rsLeasingAccountingOrderId: 2022,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
